import { useRef, useState } from 'react'
import Style from './index.module.less'
import { Input, InputRef, message, Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import useMeNavigate from '@/hooks/useMeNavigate'
import useSuperLock from '@/hooks/useSuperLock'
import { queryExists } from '@/api/common'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { useGlobalStore } from '@/hoxStore/globalStore'
const SearchInput = ({ placeholder = '文本提示' }: { placeholder: string }) => {
  const { curReponsive } = useGlobalStore()
  const { t } = useTranslation()
  const inputRef = useRef<InputRef>(null)
  const navigate = useMeNavigate()
  const [loading, setLoading] = useState(false)
  function showTips(key: 'explorer_250' | 'explorer_251') {
    // 请输入正确的交易哈希/区块高度/地址
    message.error(t(key))
  }

  const [handleSreach] = useSuperLock(async () => {
    const language = localStorage.getItem('language')
    try {
      if (loading) return
      const searchValue = (inputRef.current?.input?.value || '').trim()
      if (searchValue) {
        // 定义匹配规则
        const rules = [
          {
            condition: searchValue.length === 42 && /^gea/.test(searchValue),
          },
          {
            condition: !Number.isNaN(Number(searchValue)) && Number(searchValue) >= 1,
          },
          {
            condition: searchValue.length === 64,
          },
        ]
        // 匹配规则
        const matchedRule = rules.find((rule) => rule.condition)
        if (!matchedRule) {
          showTips('explorer_250')
          return
        }
        setLoading(true)
        const res = await queryExists(searchValue)
        setLoading(false)
        if (res.existence_check.length) {
          const result = res.existence_check[0]
          if (!result.search_type) {
            showTips('explorer_251')
            return
          }
          switch (result.search_type) {
            case 'block': // 区块
              // 区块hash不能跳转
              if (Number.isNaN(Number(searchValue))) {
                showTips('explorer_251')
                return
              }
              navigate(`/blockchain/${searchValue}`)
              break
            // hub层交易
            case 'hub_transaction': // 交易
              navigate(`/transaction/${searchValue}?net_type=hub`)
              break
            // rollup层交易
            case 'checkin_transaction': // 签到交易
              navigate(`/transaction/${searchValue}?net_type=rollup`)
              break
            case 'account': // 普通地址
              navigate(`/accountDetail/${searchValue}`)
              break
            case 'module_account': // 模块地址
              navigate(`/moduleAccount/${searchValue}`)
              break
            default:
              break
          }
        }
      }
    } catch (error) {
      setLoading(false)
      console.log('error', error)
      showTips('explorer_251')
    }
  }, 100)
  return (
    <div className={Style.wrap}>
      <span className={Style.icon}></span>
      <Input
        ref={inputRef}
        onPressEnter={handleSreach}
        variant="borderless"
        placeholder={placeholder}
        type="text"
      />
      <div onClick={handleSreach} className={classNames(Style.btn, loading && Style.loading)}>
        <div
          className={classNames({
            [Style.loading_Spin]: loading,
          })}
        >
          {loading && (
            <Spin
              indicator={<LoadingOutlined spin />}
              size={curReponsive?.size === 'mobile' ? 'small' : 'default'}
              className={Style.loadingIcon}
            />
          )}
        </div>
        {t('explorer_38')}
      </div>
      {/* <div className={Style.tipPanner}>11</div> */}
    </div>
  )
}

export default SearchInput
